import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState, Status } from "@client/types";
import { loadDetail } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  formId: string;
};
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    const detail = localState.detail[props.formId] ?? {
      error: null,
      form: null,
      status: Status.None
    };
    return {
      ...props,
      ...detail,
      isEditMode: state.isEditMode
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  loadDetail: (formId: string) => dispatch(loadDetail(props, formId))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
